import _ from "lodash";

export const clientsById = state => {
    return _.keyBy(state.clients, 'id')
}

export const availableReportSendModesByValues = state => {
    return _.keyBy(state.availableReportSendModes, 'value')
}

export const clientSpecialistsById = state => {
    //Берем всех клиентов, у которых есть специалисты, собираем у них специалистов и объединям в один массив
    const allClientSpecialists = _.flatten(
        _.map(
            _.filter(state.clients, function (c) {
                return c.specialists.length > 0
            }),
            'specialists')
    )

   return _.keyBy(allClientSpecialists, 'id')
}

export const validationErrors = state => context => {
    return _.get(state.errorMessagesByFields, [context], {})
}

export const validationErrorsByField = state => (context, fieldName) => {
    return _.get(state.errorMessagesByFields, [context, fieldName], {})
}

export const progress = state => key => {
    return _.get(state.progress, key, false)
}